import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const ReviewReply = Loadable(
  lazy(() =>
    import("./ManageReviewReply").then(({ ManageReviewReply }) => ({
      default: ManageReviewReply,
    }))
  )
);

const ReviewReplyList = Loadable(
  lazy(() =>
    import("./ReviewList").then(({ ReviewList }) => ({
      default: ReviewList,
    }))
  )
);

export const ReviewReplyRoutes = [
  {
    path: "/review",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.REVIEW]}>
        <ReviewReplyList />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/manage-review",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.REVIEW]}>
        <ReviewReply />
      </AuthorizedRoute>
    ),
  },
];
